import {useSelector} from 'react-redux';

import {Assignables} from 'nutshell-core/assignables';

import {TaskRow} from 'shells/row/task-row/task-row';
import type {TaskRowItem} from 'shells/row/task-row/types';

import type {TaskMutations, StepMutations} from '../types';

type Props = {
    tasks: TaskRowItem[];
    taskMutations?: TaskMutations;
    stepMutations?: StepMutations;
    setError: (error?: string | null | undefined) => void;
    isUpdatingTask?: boolean;
};

export function TaskList(props: Props) {
    const assignables = useSelector(Assignables.getAllEnabled);

    return (
        <>
            {props.tasks.map((task) => (
                <TaskRow
                    key={task.id}
                    task={task}
                    // @ts-expect-error
                    assignables={assignables}
                    taskMutations={props.taskMutations}
                    stepMutations={props.stepMutations}
                    setError={props.setError}
                    isUpdatingTask={props.isUpdatingTask}
                />
            ))}
        </>
    );
}
